/**
 * Convert the backend's `minimum_notice_config` into a plain number of
 * hours. The config is usually `{ value: number, type: 'hours' | 'days' }`.
 *
 * Returns 0 when:
 *   - the config is missing or malformed,
 *   - `minimum_notice_enabled` is explicitly false,
 *   - value is non-positive.
 */
export interface MinimumNoticeConfig {
  value?: number;
  type?: 'hours' | 'days';
}

export interface MinimumNoticeSource {
  minimum_notice_enabled?: boolean;
  minimum_notice_config?: MinimumNoticeConfig | null;
}

export function getMinimumNoticeHours(source?: MinimumNoticeSource): number {
  if (!source || source.minimum_notice_enabled === false) {
    return 0;
  }
  const cfg = source.minimum_notice_config;
  if (!cfg || typeof cfg.value !== 'number' || cfg.value <= 0) {
    return 0;
  }
  return cfg.type === 'days' ? cfg.value * 24 : cfg.value;
}
